import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import { ReactComponent as ChevronRightIcon } from "../../../assets/images/btn-right-aero.svg";
import { ReactComponent as TrashIcon } from "../../../assets/images/trash.svg";

import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCities,
  getAllStates,
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";
import CreatableSelect from "react-select/creatable";

const DestinationSelectionModal = ({ show, onHide, onSave, selected = [] }) => {
  const [destinations, setDestinations] = useState([
    { state: null, city: null },
  ]);
  const [selectedState, setSelectedState] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  useEffect(() => {
    const profile = store?.profileItem?.data;
    if (profile?.interested_state) {
      try {
        // Parse JSON string safely
        const parsedStates = JSON.parse(profile.interested_state);

        // Map it to desired structure
        const formattedDestinations = parsedStates.map((item) => ({
          state: {
            value: item.state || "",
            label: item.state || "",
          },
          city: {
            value: item.city || "",
            label: item.city || "",
          },
          role: item.role || "",
        }));

        setDestinations(formattedDestinations);
      } catch (error) {
        console.error("Error parsing interested_state:", error);
        // fallback if parsing fails
        setDestinations([{ state: null, city: null }]);
      }
    }
  }, [store?.profileItem]);

  useEffect(() => {
    dispatch(getAllStates());
  }, []);

  useEffect(() => {
    if (selectedState) {
      dispatch(
        getAllCities({
          search_state: selectedState.code,
        }),
      );
    }
  }, [dispatch, selectedState]);

  useEffect(() => {
    if (store?.stateItems?.data?.states) {
      const options = store?.stateItems?.data?.states?.map((state) => ({
        value: state.id,
        label: state.state_full_name,
        code: state.state,
      }));
      setStateOptions(options);
    }
    if (store?.cityItems?.data?.cities) {
      const options = store.cityItems.data.cities.map((cityObj, index) => ({
        value: cityObj.city,
        label: cityObj.city,
      }));
      setCityOptions(options);
    }
  }, [store?.stateItems, store?.cityItems]);

  // Handle dropdown changes
  const handleChange = (index, field, value) => {
    const updated = [...destinations];
    updated[index][field] = value;
    // setSelectedState(value);
    // Reset city if state changes
    if (field === "state") {
      updated[index].city = null;
    }

    setDestinations(updated);
  };

  // const onSubmit = () => {
  //   if (store?.profileItem?.data?.full_name) {
  //     const payload = {
  //       name: store?.profileItem?.data?.full_name || "",
  //       interested_state: destinations?.map((d) => ({
  //         state: d.state ? d.state.label : "",
  //         city: d.city ? d.city.label : "",
  //       })),
  //     };
  //     dispatch(updateProfile(payload));
  //   }
  // };

  const onSubmit = () => {
    if (store?.profileItem?.data?.full_name) {
      const payload = {
        name: store?.profileItem?.data?.full_name || "",
        // Convert array of objects into a JSON string
        interested_state: JSON.stringify(
          destinations?.map((d) => ({
            state: d.state?.label || "",
            city: d.city?.label || "",
          })) || [],
        ),
      };

      dispatch(updateProfile(payload));
    }
  };

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
      // dispatch(getViewProfile());
    }
  }, [store?.actionFlag, onHide]);

  // Add another destination
  const addDestination = () => {
    setDestinations((prev) => [...prev, { state: null, city: null }]);
  };

  // Remove a destination
  const removeDestination = (index) => {
    setDestinations((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "CHANGE_INTERESTED_STATE", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_INTERESTED_STATE" }));
    };
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        {/* <Modal.Title>Select Destination(s)</Modal.Title> */}
        <h5 className="modal-title">What state(s) are you interested in?</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        {destinations.map((dest, idx) => (
          <Row key={idx}>
            {/* <Row className="align-items-center">
              <Col md={10}>
                <h6 className="fw-bold">Destination {idx + 1}</h6>
                <Row>
                  <Col md={6} className="mb-3">
                    <label className="form-label">State</label>
                    <Select
                      options={stateOptions}
                      value={dest.state}
                      onChange={(option) => handleChange(idx, "state", option)}
                      placeholder="Select state..."
                    />
                  </Col>
                  <Col md={6} className="mb-3">
                    <label className="form-label">City</label>
                    <Select
                      options={dest.state ? cityOptions[dest.state.value] : []}
                      value={dest.city}
                      onChange={(option) => handleChange(idx, "city", option)}
                      placeholder="Select city..."
                      isDisabled={!dest.state}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={2} className="d-flex align-items-start justify-content-end mt-2">
                {destinations.length > 1 && (
                  <Button
                    variant="outline-danger"
                    onClick={() => removeDestination(idx)}
                  >
                    Remove
                  </Button>
                )}
              </Col>
            </Row> */}

            <Col md={6}>
              <Form.Group className="form-group">
                <Form.Label className="col-label">State</Form.Label>
                <Select
                  options={stateOptions}
                  value={dest.state}
                  // onChange={(option) => handleChange(idx, "state", option),selectedState(option.value)}
                  onChange={(option) => {
                    console.log(option, "option");
                    handleChange(idx, "state", option);
                    setSelectedState(option); // You can update your local state here
                  }}
                  menuPosition="fixed"
                  styles={{
                    menu: (base) => ({
                      ...base,
                      borderRadius: "15px",
                      marginTop: "8px",
                      backgroundColor: "var(--mmp-surface)",
                      padding: "6px",
                      zIndex: "1000",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    option: (base, state) => ({
                      ...base,
                      borderRadius: "8px",
                      padding: "10px",
                      backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                      color: "var(--mmp-text-primary)",
                      cursor: "pointer",
                      "&:active": {
                        backgroundColor: "var(--mmp-hover-bg)",
                      },
                    }),
                  }}
                  placeholder="Select state..."
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </Col>
            {/* <Col md={6}>
              <Form.Group className="form-group position-relative">
                <Form.Label className="col-label">City</Form.Label>
                <Select
                  options={cityOptions}
                  value={dest.city}
                  onChange={(option) => handleChange(idx, "city", option)}
                  menuPosition="fixed"
                  styles={{
                    menu: (base) => ({
                      ...base,
                      borderRadius: "15px",
                      marginTop: "8px",
                      backgroundColor: "var(--mmp-surface)",
                      padding: "6px",
                      zIndex: "1000",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    option: (base, state) => ({
                      ...base,
                      borderRadius: "8px",
                      padding: "10px",
                      backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                      color: "var(--mmp-text-primary)",
                      cursor: "pointer",
                      "&:active": {
                        backgroundColor: "var(--mmp-hover-bg)",
                      },
                    }),
                  }}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select city..."
                  isDisabled={!dest.state}
                />
                {destinations.length > 1 && idx !== 0 && (
                  <Button
                    variant="outline-danger"
                    className="remove-btn"
                    onClick={() => removeDestination(idx)}
                  >
                    <TrashIcon />
                  </Button>
                )}
              </Form.Group>
            </Col> */}
            <Col md={6}>
              <Form.Group className="form-group position-relative">
                <Form.Label className="col-label">City</Form.Label>

                <CreatableSelect
                  options={cityOptions}
                  value={dest.city}
                  onChange={(option) => handleChange(idx, "city", option)}
                  onCreateOption={(inputValue) => {
                    const formattedValue = inputValue.trim();
                    if (!formattedValue) return;

                    // Duplicate check (case-insensitive)
                    const isDuplicate = cityOptions.some(
                      (option) =>
                        option.value.toLowerCase() ===
                        formattedValue.toLowerCase(),
                    );

                    if (isDuplicate) {
                      alert("City already exists!");
                      return;
                    }

                    const newOption = {
                      label: formattedValue,
                      value: formattedValue,
                    };

                    // Add to global city options
                    setCityOptions((prev) => [...prev, newOption]);

                    // Update this specific destination
                    handleChange(idx, "city", newOption);
                  }}
                  formatCreateLabel={(inputValue) => `Add City "${inputValue}"`}
                  menuPosition="fixed"
                  styles={{
                    menu: (base) => ({
                      ...base,
                      borderRadius: "15px",
                      marginTop: "8px",
                      backgroundColor: "var(--mmp-surface)",
                      padding: "6px",
                      zIndex: "1000",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    option: (base, state) => ({
                      ...base,
                      borderRadius: "8px",
                      padding: "10px",
                      backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                      color: "var(--mmp-text-primary)",
                      cursor: "pointer",
                      "&:active": {
                        backgroundColor: "var(--mmp-hover-bg)",
                      },
                    }),
                  }}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select or Type City"
                  isDisabled={!dest.state}
                  isClearable
                />

                {destinations.length > 1 && idx !== 0 && (
                  <Button
                    variant="outline-danger"
                    className="remove-btn"
                    onClick={() => removeDestination(idx)}
                  >
                    <TrashIcon />
                  </Button>
                )}
              </Form.Group>
            </Col>
          </Row>
        ))}

        <Button variant="link" onClick={addDestination}>
          + Add More
        </Button>

        <div className="buttons text-center">
          <Button
            variant="primary"
            onClick={onSubmit}
            disabled={
              store?.isLoading ||
              destinations.some((d) => !d.state || !d.city)
            }
          >
            {store?.isLoading ? "Saving..." : "Save"}{" "}
            <ChevronRightIcon className="button-icon" />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DestinationSelectionModal;
